import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CREATE_SERVICE_FAILED_NETWORK_ERROR
} from '../../../constants';
import { IServiceResponseModel } from '../../../models/index';

export interface IServiceList {
  isLoading: boolean;
  serviceErrorMessage: string;
  serviceList: IServiceResponseModel;
}

/**
 * Initial Service state in store
 */
export const initialState: IServiceList = {
  isLoading: false,
  serviceErrorMessage: '',
  serviceList: {
    currentPageNumber: 0,
    numberOfPages: 0,
    numberOfRecordsPerPage: 10,
    totalRecords: 0,
    services: []
  }
};

const getServiceListSlice = createSlice({
  name: 'getServiceName',
  initialState,
  reducers: {
    getServiceListStarted: (state) => {
      state.isLoading = true;
    },

    getServiceListSuccess: (
      state,
      action: PayloadAction<IServiceResponseModel>
    ) => {
      state.isLoading = false;
      state.serviceList = action.payload;
      state.serviceErrorMessage = '';
    },

    getServiceListFail: (state) => {
      state.isLoading = false;
      state.serviceList.services = initialState.serviceList.services;
      state.serviceErrorMessage = CREATE_SERVICE_FAILED_NETWORK_ERROR;
    },

    clearServiceList: (state) => {
      state.isLoading = false;
      state.serviceList = initialState.serviceList;
      state.serviceErrorMessage = '';
    }
  }
});
export const {
  getServiceListStarted,
  getServiceListSuccess,
  getServiceListFail,
  clearServiceList
} = getServiceListSlice.actions;
export default getServiceListSlice.reducer;
